import React, { useEffect } from "react";
import { BtnBack, Icon, CarouselUi, CarouselCard2Ui } from "~/components";
import { useExplorePassions } from "../../utils/useExplorePassions";
import { TopBanner } from "./TopBanner";
import { passionsIcons } from "./passions-icons";
import { UpdateProfile } from "./UpdateProfile";
import { carouselData } from "./carousel-data";
import { useBeverages } from "../../hooks/useBeverages";
import { getPassionHeader } from "../../utils/passionsData.js";
import styles from "./CarouselExplorePage.module.css";
import { setCookie } from "../../utils/setCookie";
import { getCookie } from "../../utils/getCookie";
import { usePassions } from "../../hooks/usePassions2";
import { useAcid } from "../../hooks/useAcid";
import { jtrCookieName } from "../../hooks/useSsoRedirect";

export function CarouselExplorePage({ experienceType = "" }) {
  const passions = useExplorePassions(experienceType);
  const cid = getCookie(jtrCookieName);
  const isCid = cid && Number(cid) !== 0;
  const { acid } = useAcid();
  const { savePassionsToServer, getSelectedPassionsAsArray } = usePassions(
    isCid ? cid : experienceType,
  );
  const { saveBeveragesToServer, getSelectedBeveragesAsArray } = useBeverages();

  useEffect(() => {
    if (!isCid || !acid) {
      return;
    }

    if (experienceType === "beverage") {
      saveBeveragesToServer(acid);
    } else {
      savePassionsToServer(acid, cid);
    }
    setCookie(jtrCookieName, "", 0);
  }, [
    cid,
    acid,
    experienceType,
    isCid,
    saveBeveragesToServer,
    getSelectedBeveragesAsArray,
    savePassionsToServer,
    getSelectedPassionsAsArray,
  ]);

  return (
    <>
      <BtnBack
        trackValue="Explore Header|Back to Experience"
        type="inversion"
        className={styles.exploreBack}
      >
        <Icon
          name="arrowRight"
          size="16"
          style={{ transform: "rotateX(180deg) rotateY(180deg)" }}
        />
        Back
      </BtnBack>
      <TopBanner passions={passions} />
      {passions?.map(({ passion }, i) => {
        const data = carouselData[passion];
        const PassionIcon = passionsIcons[passion];

        return (
          <div key={passion} className={styles.carouselWrapper}>
            <div className={styles.carouselHeader}>
              <PassionIcon />
              {getPassionHeader(passion)}
            </div>
            <CarouselUi
              data-testid={`explore-carousel-${passion}`}
              key={i}
              alwaysShowButtons
              passions={[...data.slides, ...data.slides]}
              getCardView={(slide, j) => {
                return <CarouselCard2Ui key={j} item={slide} />;
              }}
            />
          </div>
        );
      })}
      <div className={styles.exploreUpdateProfile}>
        <UpdateProfile />
      </div>
    </>
  );
}
